export const APP_LINKS = {
    appStore: 'https://apps.apple.com/us/app/bitnet/id6477567064',
    googlePlay: 'https://play.google.com/store/apps/details?id=ge.bitnet',
};
//# sourceMappingURL=links.js.map